<div class="sidebar-wrapper">
  <!-- Sidebar Container -->
  @if (sidebarVisible) {
    <div
      class="sidebar-container"
      [ngClass]="this.themeService.isDarkMode ? 'darkmode' : ''"
      [ngStyle]="{ width: sidebarWidth + 'px' }"
      [style.width.px]="sidebarWidth"
      >
      <!-- Datepicker Section -->
      <div class="mds-external-nav-dp date-picker">
        <mbsc-datepicker
          [(ngModel)]="selectedDate"
          (ngModelChange)="onDateChange()"
          display="inline"
          endIcon="copy3"
          [showWeekNumbers]="true"
        ></mbsc-datepicker>
      </div>
      <div class="dropcontainer-wrapper">
        <!-- ==================== Backlog Dropcontainer ==================== -->
        <div class="sidebar-header" [ngClass]="themeService.isDarkMode ? 'darkmode' : ''">
          <div class="headline">
            <!-- Toggle Button - Expanded -->
            @if (toggleStatusBacklog) {
              <mbsc-button
                (click)="toggleSection('backlog')"
                icon="material-keyboard-arrow-down"
                title="Backlog zuklappen"
                class="template-btn"
                >
                <span class="mbsc-font-icon material-keyboard-arrow-down"></span>
              </mbsc-button>
            }
            <!-- Toggle Button - Collapsed -->
            @if (!toggleStatusBacklog) {
              <mbsc-button
                (click)="toggleSection('backlog')"
                icon="material-keyboard-arrow-up"
                title="Backlog aufklappen"
                class="template-btn"
                >
                <span class="mbsc-font-icon material-keyboard-arrow-down"></span>
              </mbsc-button>
            }
            <h3>Backlog</h3>
          </div>
          <div>
            <!-- Add Backlog Event Button -->
            <mbsc-button
              (click)="openMainPopupBacklogEvent()"
              icon="plus"
              title="Backlog Termin erstellen"
              class="template-btn"
              >
              <span class="mbsc-font-icon mbsc-icon-material-add"></span>
            </mbsc-button>
            <!-- Filter Button -->
            <mbsc-button
              icon="material-filter-list"
              class="mbsc-flex-none template-btn"
              title="Termine filtern"
              (click)="openBacklogFilter()"
              #backlogFilterButton
            ></mbsc-button>
          </div>
        </div>
        <!-- Backlog Drop Container -->
        @if (toggleStatusBacklog) {
          <mbsc-dropcontainer
            class="half-drop flex"
            [options]="backlogDropContainerOptions"
        [ngStyle]="{
          background: contBacklogBg,
          height: singleDropActive ? '85%' : '40%'
        }"
            >
            @for (task of (filteredTasks === null ? tasks : filteredTasks); track task) {
              <ng-container
                class="scroll-wrapper"
                >
                <app-event-view
                  [event]="task"
                  [filteredCustomers]="filteredCustomers"
                  [dragging]="dragging"
                  mbsc-draggable
                  style="cursor: pointer;"
                  (click)="openBacklogEvent(task)"
                  (contextmenu)="onRightClick($event, task)"
                  [dragData]="task"
                  [myEvents]="events"
                  [interpreter]="interpreter"
                ></app-event-view>
              </ng-container>
            }
            @if (filteredTasks.length === 0) {
              <div
                class="empty-drop-container"
                >
                <img
                  title="Keine Backlog Termine vorhanden"
                  src="./../../../../../assets/icons/empty-drawer.png"
                  alt=""
                  />
                </div>
              }
            </mbsc-dropcontainer>
          }
          <!-- ==================== Template Dropcontainer ==================== -->
          <div class="sidebar-header" [ngClass]="themeService.isDarkMode ? 'darkmode' : ''">
            <div class="headline">
              <!-- Toggle Button - Expanded -->
              @if (toggleStatusTemplate) {
                <mbsc-button
                  (click)="toggleSection('template')"
                  icon="material-keyboard-arrow-down"
                  title="Template zuklappen"
                  class="template-btn"
                  >
                  <span class="mbsc-font-icon material-keyboard-arrow-down"></span>
                </mbsc-button>
              }
              <!-- Toggle Button - Collapsed -->
              @if (!toggleStatusTemplate) {
                <mbsc-button
                  (click)="toggleSection('template')"
                  icon="material-keyboard-arrow-up"
                  title="Template aufklappen"
                  class="template-btn"
                  >
                  <span class="mbsc-font-icon material-keyboard-arrow-up"></span>
                </mbsc-button>
              }
              <h3>Vorlagen</h3>
            </div>
            <div>
              <!-- Add Template Button -->
              <mbsc-button
                (click)="openMainPopupTemplateEvent()"
                icon="plus"
                title="Termin Vorlage erstellen"
                class="template-btn"
              ></mbsc-button>
              <!-- Filter Button -->
              <mbsc-button
                icon="material-filter-list"
                class="mbsc-flex-none template-btn"
                (click)="openTemplateFilter()"
                #templateFilterButton
              ></mbsc-button>
              <!-- Delete Mode Button -->
              <mbsc-button
                icon="remove"
                class="mbsc-flex-none template-btn"
                (click)="showDeleteButtons()"
              ></mbsc-button>
            </div>
          </div>
          <!-- Template Drop Container -->
          @if (toggleStatusTemplate) {
            <mbsc-dropcontainer
              class="half-drop flex"
              [options]="templateDropContainerOptions"
        [ngStyle]="{
          background: contTemplateBg,
          height: singleDropActive ? '85%' : '40%'
        }"
              >
              @for (template of (filteredTemplates === null ? [] : filteredTemplates); track template) {
                <div class="event-view-container">
                  <app-event-view
                    [ngStyle]="{ width: showDeleteButtonsFlag ? '83%' : '100%' }"
                    [event]="template"
                    [filteredCustomers]="filteredCustomers"
                    [dragging]="dragging"
                    mbsc-draggable
                    style="cursor: pointer;"
                    (click)="openTemplateEvent(template)"
                    (contextmenu)="onRightClick($event, template)"
                    [dragData]="template"
                    [myEvents]="events"
                    [interpreter]="interpreter"
                  ></app-event-view>
                  <!-- Delete Button -->
                  <div>
                    @if (showDeleteButtonsFlag) {
                      <mbsc-button
                        icon="remove"
                        (click)="deleteTemplate(template); $event.stopPropagation()"
                        style="margin-left: 8px;"
                        color="danger"
                        variant="outline"
                      ></mbsc-button>
                    }
                  </div>
                </div>
              }
              @if (filteredTemplates.length === 0) {
                <div
                  class="empty-drop-container"
                  >
                  <img
                    title="Keine Vorlagen vorhanden"
                    src="./../../../../../assets/icons/empty-drawer.png"
                    alt=""
                    />
                  </div>
                }
              </mbsc-dropcontainer>
            }
          </div>
          <!-- Sidebar Controls -->
          <mbsc-button
            icon="arrow-left2"
            class="toggle-button-close"
            (click)="closeSidebar()"
          ></mbsc-button>
          <div class="resize-handle" (mousedown)="startResizing($event)"></div>
        </div>
      }

      <!-- Hidden Sidebar Toggle -->
      @if (!sidebarVisible) {
        <div class="sidebar-container-hidden">
          <mbsc-button
            icon="arrow-right2"
            class="toggle-button-open"
            (click)="openSidebar()"
          ></mbsc-button>
          <!-- Notification Badge -->
          @if (filteredTasks.length > 0 && toggleStatusBacklog) {
            <span
              class="notification-badge"
              >
              {{ filteredTasks.length > 9 ? '9+' : filteredTasks.length }}
            </span>
          }
        </div>
      }
    </div>

    <!-- ==================== Filter & Popup Components ==================== -->
    <app-filter-backlog-popup
      [tasks]="tasks"
      (filteredTasksChange)="onFilteredTasksChange($event)"
    ></app-filter-backlog-popup>

    <app-filter-template-popup
      [templates]="templates"
      (onFilteredTemplateChange)="onFilteredTemplateChange($event)"
    ></app-filter-template-popup>

    <lib-event-popup
      [filteredCustomers]="filteredCustomers"
      [tempEvent]="tempEvent"
      [myResources]="myResources"
      [showHistory]="showHistoryContainer"
      [showDeleteButtonContainer]="true"
      [showInterpreterSelection]="showInterpreterSelection"
      [showTabContainer]="showTabContainer"
      [selectedSegment]="tempEvent['type'] || 'MISSIONEVENT'"
      [myEvents]="myEvents"
      [selectedDate]="selectedDate"
      [history]="historyData"
      [popupCloseAfterTemplatePost]="popupCloseAfterTemplatePost"
      [popupCloseAfterTemplateUpdate]="popupCloseAfterTemplateUpdate"
      [popupCloseAfterEventPost]="popupCloseAfterEventPost"
      [popupCloseAfterEventUpdate]="popupCloseAfterEventUpdate"
      [popupCloseAfterEventDelete]="popupCloseAfterEventDelete"
      [travelTimeResult]="travelTimeData"
      (travelTimeRequested)="getTravelTimeWithGoogle($event)"
      (moveToBacklogFromChild)="moveToBacklog($event)"
      (saveTemplateFromChild)="postTemplateFromLib($event)"
      (updateTemplateFromChild)="updateTemplateFromLib($event)"
      (saveEventFromChild)="postEventFromLib($event)"
      (updateEventFromChild)="updateEventFromLib($event)"
      (customerSearchText)="getCustomerSearchFromLib($event)"
      (deleteEventFromChild)="deleteEventFromLib($event)"
      (updateEventHistory)="updateEventHistoryFromLib($event)"
    ></lib-event-popup>